import { defineCustomElement } from 'vue';
import { Amplify } from 'aws-amplify';
import tailwindcss from '@/styles/tailwind.css';
import icons from '@/styles/icons.css';

import Planner from '@/components/planning/Planner.ce.vue';

import { createPinia } from 'pinia'

const pinia = createPinia()

const awsconfig = {
  aws_project_region: process.env.VUE_APP_AWS_PROJECT_REGION || 'eu-west-1',
  aws_appsync_graphqlEndpoint: process.env.VUE_APP_AWS_APPSYNC_GRAPHQLENDPOINT,
  aws_appsync_region: process.env.VUE_APP_AWS_APPSYNC_REGION || 'eu-west-1',
  aws_appsync_authenticationType: 'AWS_LAMBDA'
};

Amplify.configure(awsconfig);

const PlannerElem = defineCustomElement({ 
  ...Planner, 
  styles: [tailwindcss, icons],
  configureApp(app) {
    app.use(pinia);
  }
 });

// Register the custom element globally
// ! THE NAME SHOULD BE web-component-{{name of declarion file}}-{{name of component}}
customElements.define('web-component-planner', PlannerElem);
